/**
 * Local previews for attachments in a send the server has not confirmed yet.
 * Images and videos get an object URL from the user's own file; anything else
 * (or a file whose bytes are no longer held) renders as a name chip.
 */

export interface PendingAttachmentPreview {
  key: string;
  name: string;
  contentType: string;
  /** Object URL for image/video bytes still held locally. */
  url?: string;
}

function previewable(contentType: string): boolean {
  return contentType.startsWith('image/') || contentType.startsWith('video/');
}

export function createPendingPreviews(
  files: readonly { name: string; type: string; blob: Blob }[],
  keyPrefix: string,
): PendingAttachmentPreview[] {
  return files.map((f, i) => ({
    key: `${keyPrefix}:${i}`,
    name: f.name,
    contentType: f.type,
    ...(previewable(f.type) && typeof URL.createObjectURL === 'function'
      ? { url: URL.createObjectURL(f.blob) }
      : {}),
  }));
}

export function revokePendingPreviews(previews: readonly PendingAttachmentPreview[] | undefined): void {
  if (!previews || typeof URL.revokeObjectURL !== 'function') return;
  for (const p of previews) if (p.url) URL.revokeObjectURL(p.url);
}
